import AgeVerify from './Age';
import AvatarSelection from './AvatarSelection';
import Game from './Game';
import Intro from './Intro';
import Score from './Score';

import Register from './Register';
import LeaderBoard from './Leaderboard';

export default class UI {
  constructor() {}
  init() {
    // this.privacy = new Privacy();
    // this.privacy.init();

    this.ageVerify = new AgeVerify();
    this.ageVerify.init();

    this.register = new Register();
    this.register.init();

    this.avatarSelection = new AvatarSelection();
    this.avatarSelection.init();

    this.score = new Score();
    this.score.init();

    this.leader = new LeaderBoard();
    this.leader.init();

    this.intro = new Intro();
    this.intro.init();

    this.game = new Game();
    this.game.init();
  }
}
